import React from "react";
import { formatCurrency } from "../../../helpers/estimateTotals";
import { formatTaxLineLabel } from "../../../helpers/estimateTax";
import { getInvoiceTotalPresentation } from "../../../helpers/invoiceReport";
import { getVisibleInvoiceSectionSubtotals } from "../../../helpers/invoiceReportLayout";

export function InvoiceReportTotalSection({
  reportModel,
  variant = "preview",
}) {
  const presentation = getInvoiceTotalPresentation(reportModel);
  if (!presentation) return null;

  const isPrint = variant === "print";
  const rowClass = isPrint ? "erp-totals-row" : "er-summary-row";
  const emphasisRowClass = isPrint
    ? "erp-totals-row erp-totals-row--grand"
    : "er-summary-row er-summary-row--emphasis";
  const sectionSubtotals = getVisibleInvoiceSectionSubtotals(reportModel);

  const showTaxBreakdown = presentation.mode === "withTax";
  const showLineSubtotal =
    showTaxBreakdown &&
    presentation.lineSubtotal != null &&
    sectionSubtotals.length !== 1;

  return (
    <div className="invoice-totals-panel">
      {sectionSubtotals.map((row) => (
        <div key={row.id} className={rowClass}>
          <span>{row.label}</span>
          <span>{formatCurrency(row.amount)}</span>
        </div>
      ))}

      {showLineSubtotal && (
        <div className={rowClass}>
          <span>Line Subtotal</span>
          <span>{formatCurrency(presentation.lineSubtotal)}</span>
        </div>
      )}

      {showTaxBreakdown && Number(presentation.projectDiscountPercent) > 0 && (
        <div className={rowClass}>
          <span>
            Project Discount ({presentation.projectDiscountPercent}%)
          </span>
          <span>{formatCurrency(presentation.afterProjectDiscount)}</span>
        </div>
      )}

      {showTaxBreakdown && Number(presentation.goodwillAdjustment) !== 0 && (
        <div className={rowClass}>
          <span>Goodwill Adjustment</span>
          <span>{formatCurrency(presentation.goodwillAdjustment)}</span>
        </div>
      )}

      {showTaxBreakdown && (
        <>
          <div className={rowClass}>
            <span>Taxable Subtotal</span>
            <span>{formatCurrency(presentation.subtotal)}</span>
          </div>
          {presentation.lines.map((line) => (
            <div key={`${line.type}-${line.label}`} className={rowClass}>
              <span>{formatTaxLineLabel(line)}</span>
              <span>{formatCurrency(line.amount)}</span>
            </div>
          ))}
        </>
      )}

      <div className={emphasisRowClass}>
        <span>{presentation.totalLabel}</span>
        <span>{formatCurrency(presentation.total)}</span>
      </div>
    </div>
  );
}
